import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { CssBaseline, StyledEngineProvider } from '@mui/material';
import { ThemeProvider,createTheme  } from '@mui/material/styles';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { UserProvider } from './Hooks/UserContext';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import ErrorBoundary from './Component/ErrorBoundary';
import axios from 'axios';
import { rewriteLocalPathsInData } from './Utils/mediaUrl';

// Rewrite local upload paths in every API response → /api/uploads/...
axios.interceptors.response.use(
  (response) => {
    try {
      if (response?.data) {
        response.data = rewriteLocalPathsInData(response.data);
      }
    } catch (_) {}
    return response;
  },
  (error) => Promise.reject(error)
);

const root = ReactDOM.createRoot(document.getElementById('root'));
const theme = createTheme ()
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <UserProvider>
        <ToastContainer />
        <CssBaseline>
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme} >
              <BrowserRouter>
                <LocalizationProvider dateAdapter={AdapterDayjs} >
                  <App />
                </LocalizationProvider>
              </BrowserRouter>
            </ThemeProvider>
          </StyledEngineProvider>
        </CssBaseline>
      </UserProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
